export default {
    installments: [],
    sites: [],
    contractId: null,
}
